document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('#CartDrawer');
  const prioToggle = document.querySelector('#ck-prio-product-toggle');
  const variantDataEl = document.querySelector('[data-ck-prio-product]');
  const prioContainer = document.querySelector('.ck-prio-product__toggle');

  // --- Helpers ---
  async function getPrioVariantId() {
    if (!variantDataEl || !prioContainer) return null;
    try {
      const selectedTitle = prioContainer.dataset.variant;
      const variants = JSON.parse(variantDataEl.textContent || '[]');
      const match = variants.find(v => v.title === selectedTitle);
      return match ? match.id : null;
    } catch {
      return null;
    }
  }

  async function ensurePrioNotAlone() {
    try {
      const prioVariantId = await getPrioVariantId();
      if (!prioVariantId) return;

      const cart = await fetch('/cart.js').then(r => r.json());
      if (!Array.isArray(cart.items)) return;

      const prioItem = cart.items.find(i => i.variant_id === prioVariantId);

      // If the cart has only 1 item and it's the prio product, remove it.
      if (prioItem && cart.items.length === 1) {
        console.log('Removing priority product because it is the only item left...');
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: prioItem.key, quantity: 0 })
        });
      }
    } catch (err) {
      console.warn('ensurePrioNotAlone failed:', err);
    }
  }

  // 🔧 Patch fetch so any cart mutation triggers a check afterwards
  (function patchCartFetch() {
    const origFetch = window.fetch;
    window.fetch = async function patchedFetch(input, init = {}) {
      const res = await origFetch(input, init);
      try {
        const url = typeof input === 'string' ? input : input?.url || '';
        const method = (init?.method || 'GET').toUpperCase();
        const isCartMutation =
          method !== 'GET' &&
          (/\/cart\/add\.js$|\/cart\/change\.js$|\/cart\/update\.js$/.test(url));

        if (isCartMutation) {
          // Tiny delay so the cart state reflects the mutation
          setTimeout(ensurePrioNotAlone, 60);
        }
      } catch { /* noop */ }
      return res;
    };
  })();

  // Run once on load in case drawer renders a stale cart
  ensurePrioNotAlone();

  // --- your existing toggle removal (unchanged) ---
  let isRemovingPrio = false;

  if (prioToggle && variantDataEl && prioContainer) {
    prioToggle.addEventListener('change', async function () {
      if (isRemovingPrio) {
        console.warn('[Prio Toggle] Already processing removal, ignoring extra toggle');
        return;
      }
  
    // If user re-checked, do nothing
    if (prioToggle.checked) return;
  
      isRemovingPrio = true;
      prioContainer.classList.add('loading');
  
      try {
        const selectedTitle = prioContainer.dataset.variant;
        const variants = JSON.parse(variantDataEl.textContent || '[]');
        const match = variants.find(v => v.title === selectedTitle);
        if (!match) {
          console.warn('[Prio Toggle] Could not resolve variant');
          return;
        }
  
        const prioVariantId = match.id;
  
        // Step 1: fetch current cart
        let cart = await fetch('/cart.js').then(r => r.json());
        const prioItems = cart.items.filter(i => i.variant_id === prioVariantId);
  
        if (prioItems.length === 0) {
          console.log('[Prio Toggle] No prio items found → nothing to remove');
        } else {
        // Step 2: remove all prio items
          console.log(`[Prio Toggle] Removing ${prioItems.length} prio items…`);
            for (const item of prioItems) {
              await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
          });
            }
  
        // Step 3: short wait, then verify removal
          await new Promise(res => setTimeout(res, 50));
            cart = await fetch('/cart.js').then(r => r.json());
            const stillThere = cart.items.find(i => i.variant_id === prioVariantId);
            if (stillThere) {
              console.warn('[Prio Toggle] Prio still present after removal, retrying…');
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: stillThere.key, quantity: 0 })
              });
            }
          }
  
          console.log('[Prio Toggle] Removal complete ✅');
        } catch (error) {
          console.error('[Prio Toggle] Failed to remove prio product:', error);
        } finally {
          isRemovingPrio = false;
          prioContainer.classList.remove('loading');
        }
      });
    }
  

  // --- checkout handler ---
    let isAddingPrio = false;
    console.log(isAddingPrio)

    document.addEventListener('click', async (e) => {
      const checkoutButton = e.target.closest('#CartDrawer-Checkout');
      if (!checkoutButton) return;
  
      e.preventDefault();
      if (isAddingPrio) {
        console.warn('[Prio Checkout] Already processing, ignoring extra click');
        return;
      }
  
      isAddingPrio = true;
      checkoutButton.disabled = true;
      checkoutButton.classList.add('disabled');
  
      try {
        console.log('[Prio Checkout] Checkout clicked');
  
        const prioToggle = document.querySelector('#ck-prio-product-toggle');
        const variantDataEl = document.querySelector('[data-ck-prio-product]');
        const prioContainer = document.querySelector('.ck-prio-product__toggle');
  
        if (!prioToggle || !prioToggle.checked || !prioContainer || !variantDataEl) {
          console.log('[Prio Checkout] No active prio toggle → direct checkout');
          window.location.href = '/checkout';
          return;
        }
  
        // Get prio variant ID
        const variants = JSON.parse(variantDataEl.textContent || '[]');
        const selectedTitle = prioContainer.dataset.variant;
        const match = variants.find(v => v.title === selectedTitle);
        const prioVariantId = match ? match.id : null;
  
        if (!prioVariantId) {
          console.warn('[Prio Checkout] Could not resolve variant → direct checkout');
          window.location.href = '/checkout';
          return;
        }
  
        // Double-check the cart right before adding
        const cart = await fetch('/cart.js').then(r => r.json());
        const alreadyInCart = cart.items.some(
          //i => i.variant_id === prioVariantId && i.properties && i.properties._isPrio
          i => i.variant_id === prioVariantId
        );
  
        if (alreadyInCart) {
          console.log('[Prio Checkout] Prio already in cart, skipping add');
        } else {
          console.log('[Prio Checkout] Adding prio item…');
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: prioVariantId,
              quantity: 1,
              properties: { _isPrio: true }
            })
          });
  
          // Wait a bit for Shopify to update
          await new Promise(res => setTimeout(res, 400));
        }
  
        // Fallback clean-up: ensure only one prio item remains
        const freshCart = await fetch('/cart.js').then(r => r.json());
        const prioItems = freshCart.items.filter(i => i.variant_id === prioVariantId);
        if (prioItems.length > 1) {
          console.warn(`[Prio Checkout] Found ${prioItems.length} duplicates, cleaning up…`);
          for (let i = 1; i < prioItems.length; i++) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: prioItems[i].key, quantity: 0 })
            });
          }
        }
  
        // Proceed to checkout
        window.location.href = '/checkout';
  
      } catch (err) {
        console.error('[Prio Checkout] Failed:', err);
        window.location.href = '/checkout';
      } finally {
        isAddingPrio = false;
        checkoutButton.disabled = false;
        checkoutButton.classList.remove('disabled');
      }
    });
});